import styled from 'styled-components';

export default styled.section`
    margin: 2rem auto;
    padding: 1rem 1rem;
    text-align: ${props => props.center ? 'center' : 'left'};
    width: 850px;
`;
